<template>
  <div>
    <div class="header">
      广告主ID({{ add_title_list.length }}/1000)
      <el-button type="text" size="mini" @click="clearAll">清空</el-button>
    </div>
    <div class="mian_box">
      <ul class="left_lable">
        <li v-for="(item,index) in lable_length" :key="index">{{ index+1 }}</li>
      </ul>
      <div class="right_input">
        <div v-for="(item, index) in add_title_list" :key="index">
          <input
            ref="inputRename"
            v-model="item.id"
            :class="{'input-action':title_input_index === index}"
            placeholder="请输入或粘贴广告主id或名称，每行一个，敲击回车换行"
            @keydown="inputDown"
            @keyup="inputUp"
            @focus="setFocusIndex(index)"
            @blur="blurEvent"
          >
          <i
            v-if="title_input_index != index"
            class="el-icon-close"
            @click.stop="delectItemTitle(item)"
          />
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="submitAdvertiser">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      add_title_list: [
        {
          id: '',
        },
      ],
      lable_length: 249,
      key_code: '',
      title_input_index: 0, // 当前行索引
    };
  },
  methods: {

    // 松开按键
    inputUp(event) {
      if (event.keyCode === 13 || (this.key_code === 17 && event.keyCode === 86)){
        const s = this;
        this.blurEvent();
        if (this.add_title_list.length < s.lable_length) {
          this.title_input_index++;
          if (this.title_input_index === this.add_title_list.length) {
            this.add_title_list.push({
              id: '',
            });
          }
          this.$nextTick(() => {
            s.$refs.inputRename[this.title_input_index].focus();
          });
        }
      }
    },

    // 焦点事件
    blurEvent() {
      const val = this.add_title_list[this.title_input_index].id;
      const temp_list = val.split(/\s+/);

      for (let i = 0; i < temp_list.length; i++) {
        const item = temp_list[i];
        if (i > 0) {
          this.add_title_list.push({
            id: item,
          });
          this.title_input_index = this.add_title_list.length - 1;
        } else {
          this.add_title_list[this.title_input_index].id = item;
        }
      }
    },

    // 删除新增标题
    delectItemTitle(item) {
      const index = this.add_title_list.indexOf(item);
      if (this.add_title_list.length > 1) {
        this.add_title_list.splice(index, 1);
        if (this.add_title_list.length === 1) {
          this.title_input_index = 0;
        }
      }
    },

    // 清空所有的广告主
    clearAll(){
      this.add_title_list = [
        {
          id: '',
        },
      ];
    },

    // 设置焦点索引
    setFocusIndex(index) {
      this.title_input_index = index;
    },

    // 输入框摁下ctrl
    inputDown(event){
      if (event.keyCode !== 86){
        this.key_code = event.keyCode;
      }
    },

    // 取消批量
    cancel(){
      this.$emit('cancel');
    },

    // 提交广告主
    submitAdvertiser(){
      const list = this.add_title_list.map(item => {
        return item.id;
      });
      this.$emit('config', list);
    },
  },
};
</script>
<style rel="stylesheet/scss" scoped lang="scss">
.header{
  width: 90%;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  background-color: #edf1f5;
  padding-left: 35px;
 .el-button{
   float: right;
   margin-right: 50px;
 }
}
.mian_box{
  width: 90%;
  height: 400px;
  overflow: auto;
  margin: 0 auto;
  .left_lable{
    padding: 0;
    margin: 0;
    width: 5%;
    float: left;
    background-color: #edf1f5;
    li{
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
    }
  }
  .right_input{
    float: right;
    width: 95%;
    input{
      width: 96%;
      height: 36px;
      border: none;
    }
    span{
      display: block;
      float: right;
      width: 5%;
      line-height: 36px;
      text-align: center;
      background: #edf1f5;
    }
    .input-action{
      background-color: #edf1f5;
    }
  }
}
.dialog-footer{
  text-align: center;
}
</style>
